module.exports = __webpack_public_path__ + "static/media/instagram-3x.9784af89.png";